'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$00247 from "./presto.-Agent-View$$anon$7.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dOpened$0024 from "./presto.-Agent-View$-Opened$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$6() {
  this.aAC = null;
  this.aAu = null;
  this.aAv = false;
  this.aAD = null;
  this.aAE = false;
  this.aAH = null;
  this.aAA = null;
  this.aAB = false;
  this.aAw = null;
  this.aAx = false;
  this.aAy = null;
  this.aAz = false;
  this.aAF = false;
  this.aAG = false;
  this.aAC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aAH = "Opened";
}
export { $c_Lpresto_AgentView$$anon$6 as $c_Lpresto_AgentView$$anon$6 };
$p = $c_Lpresto_AgentView$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$6;
/** @constructor */
function $h_Lpresto_AgentView$$anon$6() {
}
export { $h_Lpresto_AgentView$$anon$6 as $h_Lpresto_AgentView$$anon$6 };
$h_Lpresto_AgentView$$anon$6.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.aAC;
});
$p.M = (function() {
  if ((!this.aAv)) {
    this.aAu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aAv = true;
  }
  return this.aAu;
});
$p.O = (function() {
  if ((!this.aAE)) {
    this.aAD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aAE = true;
  }
  return this.aAD;
});
$p.D = (function() {
  return this.aAH;
});
$p.t = (function() {
  if ((!this.aAB)) {
    this.aAA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.aAB = true;
  }
  return this.aAA;
});
$p.N = (function() {
  if ((!this.aAx)) {
    this.aAw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.aAx = true;
  }
  return this.aAw;
});
$p.Q = (function() {
  if ((!this.aAz)) {
    this.aAy = new $j_presto$002e$002dAgent$002dView$0024$0024anon$00247.$c_Lpresto_AgentView$$anon$7();
    this.aAz = true;
  }
  return this.aAy;
});
$p.v = (function() {
  if ((!this.aAG)) {
    this.aAF = false;
    this.aAG = true;
  }
  return this.aAF;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee57) => ((p) => \u03b4scrutinee57))($j_presto$002e$002dAgent$002dView$0024$002dOpened$0024.$m_Lpresto_AgentView$Opened$())));
});
var $d_Lpresto_AgentView$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$6, "presto.AgentView$$anon$6", ({
  Eg: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$6 as $d_Lpresto_AgentView$$anon$6 };
//# sourceMappingURL=presto.-Agent-View$$anon$6.js.map
